import { render } from "./CardPregunta.vue?vue&type=template&id=116ec77e"
import script from "./CardPregunta.vue?vue&type=script&lang=js"
export * from "./CardPregunta.vue?vue&type=script&lang=js"

import "./CardPregunta.vue?vue&type=style&index=0&id=116ec77e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__